<template>
  <div>
    <div v-if="showrrprice">
      <label>RRP:</label>
      <span class="retail-price">
        {{ rrpprice | currency }}
      </span>
    </div>
    <div>
      <label>Price:</label>
      <span class="sale-price">
        {{ sellPrice | currency }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ecommerce-product-price',
  props: {
    'item': {
      type: Object,
      required: true
    },
    showrrprice: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    onRequest() {
      if (this.$store.getters['user/userid'] === '1') return false
      return this.item.catalogproductaccess && this.item.catalogproductaccess.length !== 0 && !this.$store.getters['user/hasAnyRole'](this.item.catalogproductaccess.map(data => data.role))
    },
    showPrice() {
      if (!this.onRequest || !this.item.noaccess_option) return true
      if (this.item.noaccess_option === 'show' || this.item.noaccess_option === 'hide_club') return true
      return false
    },
    rrpprice: function() {
      return parseFloat(this.item.rrp).toFixed(2)
    },
    sellPrice: function() {
      // if (this.item.product_settings != null) {
      //   return (parseFloat(this.item.product_settings.prices.base_price) + parseFloat(this.$store.getters['ecommerce/getTotalPriceAdjustment'](this.item))).toFixed(2)
      // }
      // else {
      return (parseFloat(this.item.productsettings.prices.base_price) + parseFloat(this.$store.getters['products/getResolvedTotalPriceAdjustment'](this.item))).toFixed(2)
      // }
    }
  }
}
</script>

<style scoped></style>
